<template>
   <v-container fluid>
      <v-row no-gutters class="pa-0">
         <v-col cols="12">
            <v-toolbar flat outlined>
               <v-btn
                  :disabled="multiselect || !$globalstore.UserHasCap(CapConstant.MANAGE_EVENTLIST)"
                  small
                  outlined
                  color="indigo"
                  class="pa-1"
                  @click="showAddEventDialog"
               >
                  <v-icon left small>mdi-plus</v-icon>
                  <template v-if="$vuetify.breakpoint.mdAndUp">Add Event</template>
               </v-btn>
               <v-btn
                  :disabled="!multiselect"
                  small
                  outlined
                  color="indigo"
                  class="ml-2 pa-1"
                  @click="multieventShowForm"
               >
                  <v-icon left small>mdi-calendar-multiple</v-icon>
                  <template v-if="$vuetify.breakpoint.mdAndUp">
                     Multi Event Update
                  </template>
               </v-btn>

               <v-spacer></v-spacer>
               <v-checkbox
                  :disabled="!$globalstore.UserHasCap(CapConstant.MANAGE_EVENTLIST)"
                  v-model="multiselect"
                  class="pt-4 pb-0"
                  label="Select"
               >
               </v-checkbox>
            </v-toolbar>
         </v-col>
      </v-row>
      <v-row no-gutters class="pa-0">
         <v-col cols="12">
            <v-card flat outlined class="overflow-y-auto">
               <v-data-table
                  v-model="selectedeventlist"
                  dense
                  :headers="eventHeaders"
                  :items="event_eventdata"
                  item-key="event_id"
                  :single-select="!multiselect"
                  :show-select="multiselect"
                  @click:row="eventdata_rowClick"
               >
                  <!-- eslint-disable-next-line -->
                  <template v-slot:item.event_description="{item}">
                     {{ item.event_description | ellipsetext(50) }}
                  </template>

                  <!-- eslint-disable-next-line -->
                  <template v-slot:item.actions="{item}">
                     <template v-if="$globalstore.UserHasCap(CapConstant.MANAGE_EVENTLIST)">
                        <template v-if="item.event_date > todayDate()">
                           <v-icon small class="mr-2" @click.stop="editEvent(item)">
                              mdi-pencil
                           </v-icon>
                        </template>
                        <template v-if="item.event_date > todayDate()">
                           <v-icon class="mr-2" small @click.stop="deleteEvent(item)">
                              mdi-delete
                           </v-icon>
                        </template>
                        <template v-if="item.event_date <= todayDate()">
                           <v-icon small @click.stop="showAttendance(item)">
                              mdi-account-outline
                           </v-icon>
                        </template>
                     </template>
                  </template>
               </v-data-table>
               <!-- Dialog for editing events -->
               <template>
                  <v-dialog v-model="editeventdlg" persistent max-width="500">
                     <v-card height="450">
                        <v-toolbar dense flat color="primary white--text">
                           Edit Event: {{ event_editdate }}
                           <v-spacer></v-spacer>
                           <v-btn class="mx-2" @click="editeventdlg = false">Cancel </v-btn>
                           <v-btn class="mx-2" @click="eventUpdateEvent">
                              Save
                           </v-btn>
                        </v-toolbar>

                        <v-card-text>
                           <v-form ref="editeventform">
                              <v-row no-gutters>
                                 <v-col cols="12">
                                    <v-text-field
                                       v-model="event_edit_description"
                                       label="Description"
                                       type="text"
                                       :counter="DescriptionMaxLength"
                                       :maxlength="DescriptionMaxLength"
                                       :rules="[(v) => !!v || 'Description is required']"
                                    >
                                    </v-text-field>
                                 </v-col>
                              </v-row>
                              <v-row no-gutters class="pt-3">
                                 <v-col md="12">
                                    <label>Start Time</label>
                                    <vue-timepicker
                                       auto-scroll
                                       close-on-complete
                                       v-model="event_edit_starttime"
                                       class="ml-3"
                                       name="event_start"
                                       :minute-interval="$globalstore.minute_interval"
                                    >
                                    </vue-timepicker>
                                 </v-col>
                              </v-row>
                              <v-row>
                                 <v-col md="12">
                                    <label class="ml-2">End Time</label>
                                    <vue-timepicker
                                       auto-scroll
                                       close-on-complete
                                       v-model="event_edit_endtime"
                                       class="ml-3"
                                       name="event_end"
                                       :minute-interval="$globalstore.minute_interval"
                                    ></vue-timepicker>
                                 </v-col>
                              </v-row>
                              <v-row class="mt-2">
                                 <v-col>
                                    <v-autocomplete
                                       class="pt-3"
                                       dense
                                       v-model="event_edit_location"
                                       :items="event_locationdata"
                                       label="Location"
                                       item-text="location_name"
                                       item-value="location_name"
                                       return-object
                                    ></v-autocomplete>
                                 </v-col>
                              </v-row>
                              <v-row class="mt-2">
                                 <v-col cols="12" md="12">
                                    <v-text-field
                                       :disabled="disableSpecialLocation"
                                       dense
                                       label="Special Location"
                                       v-model="event_edit_special_location"
                                    ></v-text-field>
                                 </v-col>
                              </v-row>
                           </v-form>
                        </v-card-text>
                     </v-card>
                  </v-dialog>
               </template>
            </v-card>
         </v-col>
      </v-row>
      <!-- Dialog for adding event -->
      <template>
         <v-dialog v-model="addeventdlg" persistent max-width="500">
            <v-card height="500">
               <v-toolbar dense flat color="primary white--text">
                  Add Event
                  <v-spacer></v-spacer>
                  <v-btn class="mx-2" @click="addeventdlg = false">Cancel </v-btn>
                  <v-btn class="mx-2" @click="addNewEvent"> Save </v-btn>
               </v-toolbar>
               <v-form ref="addeventform">
                  <v-card-text>
                     <v-row no-gutters>
                        <v-col cols="6" md="6">
                           <datepicker-dialog
                              class="mt-0 pt-0"
                              :indate.sync="event_add_date"
                              labelname="Event Date"
                              @return-date="onEventDateChange"
                           >
                           </datepicker-dialog>
                        </v-col>
                        <v-col cols="6" md="6">
                           <v-select
                              class="pl-4"
                              v-model="event_edit_freqtype"
                              :items="eventFreqType"
                              item-text="text"
                              item-value="id"
                              label="Event Type"
                              return-object
                           >
                           </v-select>
                        </v-col>
                     </v-row>
                     <v-row no-gutters>
                        <v-col cols="12">
                           <v-text-field
                              v-model="event_add_description"
                              label="Description"
                              required
                              type="text"
                              :counter="DescriptionMaxLength"
                              :maxlength="DescriptionMaxLength"
                              :rules="[(v) => !!v || 'Description is required']"
                           >
                           </v-text-field>
                        </v-col>
                     </v-row>
                     <v-row no-gutters class="pt-3">
                        <v-col cols="6" md="6">
                           <label>Start Time</label>
                           <vue-timepicker
                              auto-scroll
                              close-on-complete
                              v-model="event_add_starttime"
                              class="ml-3"
                              name="addevent_start"
                              :minute-interval="$globalstore.minute_interval"
                              manual-input
                           >
                           </vue-timepicker>
                        </v-col>
                        <v-col cols="6" md="6">
                           <label class="ml-2">End Time</label>
                           <vue-timepicker
                              auto-scroll
                              close-on-complete
                              v-model="event_add_endtime"
                              class="ml-3"
                              name="addevent_end"
                              :minute-interval="$globalstore.minute_interval"
                              manual-input
                           ></vue-timepicker>
                        </v-col>
                     </v-row>

                     <v-row no-gutters>
                        <v-col>
                           <v-autocomplete
                              class="pt-3"
                              dense
                              v-model="event_add_location"
                              :items="event_locationdata"
                              label="Location"
                              item-text="location_name"
                              item-value="location_name"
                              return-object
                           ></v-autocomplete>
                        </v-col>
                     </v-row>
                     <v-row class="mt-2">
                        <v-col cols="12" md="12">
                           <v-text-field
                              :disabled="disableSpecialLocation"
                              dense
                              label="Special Location"
                              v-model="event_add_special_location"
                           ></v-text-field>
                        </v-col>
                     </v-row>
                  </v-card-text>
               </v-form>
            </v-card>
         </v-dialog>
      </template>
      <!-- Dialog for multi event update -->
      <template>
         <v-dialog v-model="multieventdlg" persistent max-width="500">
            <v-card height="400">
               <v-toolbar dense flat color="primary white--text">
                  Multiple Event Update
                  <v-spacer></v-spacer>
                  <v-btn class="mx-2" @click="multieventdlg = false">Cancel </v-btn>
                  <v-btn class="mx-2" @click="multiUpdateEvent"> Save </v-btn>
               </v-toolbar>
               <v-form ref="multieventform">
                  <v-card-text>
                     <v-row no-gutters>
                        <v-col cols="12">
                           <v-text-field
                              v-model="multievent_description"
                              label="Description"
                              type="text"
                              :counter="DescriptionMaxLength"
                              :maxlength="DescriptionMaxLength"
                              required
                              :rules="[(v) => !!v || 'Description is required']"
                           >
                           </v-text-field>
                        </v-col>
                     </v-row>
                     <v-row no-gutters class="pt-3">
                        <v-col md="12">
                           <label>Start Time</label>
                           <vue-timepicker
                              auto-scroll
                              close-on-complete
                              v-model="multievent_starttime"
                              class="ml-3"
                              name="multievent_start"
                              :minute-interval="$globalstore.minute_interval"
                           >
                           </vue-timepicker>
                        </v-col>
                     </v-row>
                     <v-row>
                        <v-col md="12">
                           <label class="ml-2">End Time</label>
                           <vue-timepicker
                              auto-scroll
                              close-on-complete
                              v-model="multievent_endtime"
                              class="ml-3"
                              name="multievent_end"
                              :minute-interval="$globalstore.minute_interval"
                           ></vue-timepicker>
                        </v-col>
                     </v-row>
                     <v-row class="mt-2">
                        <v-col>
                           <v-card flat outlined class="pt-2">
                              <v-autocomplete
                                 class="pt-3 ml-4"
                                 dense
                                 v-model="multievent_location"
                                 :items="event_locationdata"
                                 label="Location"
                                 item-text="location_name"
                                 item-value="location_name"
                                 return-object
                              ></v-autocomplete>
                           </v-card>
                        </v-col>
                     </v-row>
                  </v-card-text>
               </v-form>
            </v-card>
         </v-dialog>
      </template>
      <confirm-dlg ref="confirm"></confirm-dlg>
      <confirm-reason-dlg ref="confirmreason" @save-reason="saveDeleteReason"></confirm-reason-dlg>
      <show-toast ref="toast"></show-toast>
   </v-container>
</template>

<script>
   import CapConstant from "@/common/capconstant.js";
   import {DESCRIPTION_MAXLENGTH} from "@/common/constant.js";
   import ConfirmDlg from "@/components/ConfirmDlg.vue";
   import DatepickerDialog from "@/components/DatepickerDialog.vue";
   import VueTimepicker from "vue2-timepicker/src/vue-timepicker.vue";
   import ConfirmReasonDlg from "@/components/ConfirmReasonDlg.vue";
   import ShowToast from "@/components/showToast.vue";

   export default {
      inject: ["ShowMessage"],

      props: {
         cca_id: [Number, String],
         eventlist: Array,
      },
      components: {
         ConfirmDlg,
         VueTimepicker,
         DatepickerDialog,
         ConfirmReasonDlg,
         ShowToast,
      },

      data() {
         ConfirmDlg;
         return {
            CapConstant: Object.freeze(CapConstant),

            eventFreqType: [
               {id: 0, text: "Normal"},
               {id: 1, text: "Special"},
            ],

            NORMAL_EVENT: 0,
            SPECIAL_EVENT: 1,

            DescriptionMaxLength: DESCRIPTION_MAXLENGTH,

            event_eventdata: this.eventlist,
            eventdata_rowindex: -1,
            event_edit_eventid: null,
            event_editdate: "",
            event_edit_freqtype: null, // Default to normal
            event_edit_description: "",
            event_edit_starttime: "",
            event_edit_endtime: "",
            event_edit_location: null,
            event_edit_special_location: "",
            event_locationdata: [],
            event_edit_cca_fee: "",
            event_edit_consent_required: false,
            selectedeventlist: [],
            multiselect: false,
            editeventdlg: false,
            event_add_date: "",
            event_add_description: "",
            event_add_starttime: "",
            event_add_endtime: "",
            event_add_location: null,
            event_add_special_location: "",
            // event_add_cca_fee: "",
            // event_add_consent_required: false,
            deleteReason: "",
            addeventdlg: false,
            rules_cca_fee: [
               (v) => !!/^\d+(\.\d{2})+$|^$|^\s$/.test(v) || "CCA fee must be a decimal.",
            ],
            multieventdlg: false,
            multievent_description: "",
            multievent_starttime: "",
            multievent_endtime: "",
            multievent_location: null,
            multievent_consent_required: false,

            eventHeaders: [
               {
                  text: "Date",
                  align: "start",
                  value: "event_date",
                  width: "10%",
                  class: this.$globalstore.table_smallheaderclass,
                  filter: (value) => {
                     if (!this.multiselect) return true;
                     else {
                        return value > this.todayDate();
                     }
                  },
               },
               {
                  text: "Day",
                  value: "daytext",
                  width: "7%",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Time",
                  value: "timetext",
                  width: "10%",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Description",
                  value: "event_description",
                  width: "35%",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Location",
                  value: "location_name",
                  class: this.$globalstore.table_smallheaderclass,
                  width: "18%",
               },
               // {
               //    text: "Fee",
               //    value: "cca_fee",
               //    width: "100px",
               //    class: this.$globalstore.table_smallheaderclass,
               // },
               {
                  text: "Type",
                  value: "evttypetext",
                  width: "10%",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "",
                  value: "actions",
                  width: "10%",
                  class: this.$globalstore.table_smallheaderclass,
               },
            ],
         };
      },
      computed: {
         disableSpecialLocation() {
            if (this.event_edit_freqtype) {
               if (this.event_edit_freqtype.id == 1) {
                  return false;
               } else {
                  this.event_add_special_location = "";
                  return true;
               }
            } else return true;
         },
      },

      methods: {
         todayDate() {
            //return new Date().toISOString().substr(0, 10);
            return this.$globalstore.currentDateISOString().substr(0, 10);
         },

         multieventShowForm() {
            if (this.selectedeventlist.length > 0) {
               // Use the field values from the first item selected.
               let item = this.selectedeventlist[0];
               this.multievent_description = item.event_description;
               this.multievent_starttime = item.event_starttime;
               this.multievent_endtime = item.event_endtime;
               this.multievent_location = item.event_location_id;
               this.multievent_location = this.event_locationdata.find(
                  (x) => x.location_id == item.event_location_id
               );
               this.multieventdlg = true;
            } else {
               this.ShowMessage({
                  title: "Error",
                  message: "Please select events for the update.",
                  color: "red",
               });
            }
         },

         async doMultiUpdateEvent() {
            let event_idlist = this.selectedeventlist.map((obj) => obj.event_id);
            await this.$http({
               url: "/cca/updatemultievent.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  event_description: this.multievent_description,
                  event_starttime: this.multievent_starttime,
                  event_endtime: this.multievent_endtime,
                  event_location_id: this.multievent_location.location_id,
                  event_idlist: event_idlist,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.reloadEventList();
                  }
               }
            });
         },

         async multiUpdateEvent() {
            if (!this.$refs.multieventform.validate()) {
               this.ShowMessage({
                  title: "Error",
                  message: "Please complete the form.",
                  color: "red",
               });
            } else if (this.selectedeventlist.length == 0) {
               this.ShowMessage({
                  title: "Error",
                  message: "Please select the events for the update.",
                  color: "red",
               });
            } else {
               if (this.multievent_endtime < this.multievent_starttime) {
                  this.ShowMessage({
                     title: "Error",
                     message: "End time must be greater than start time.",
                     color: "red",
                  });
               } else {
                  this.doMultiUpdateEvent();
                  this.multieventdlg = false;
               }
            }
         },

         async doAddNewEvent() {
            this.addeventdlg = false;
            let evtdate = new Date(this.event_add_date);
            let dow = evtdate.getDay();
            await this.$http({
               url: "/cca/addevent.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  cca_id: this.cca_id,
                  event_date: this.event_add_date,
                  start: this.event_add_starttime,
                  end: this.event_add_endtime,
                  dow: dow,
                  description: this.event_add_description,
                  location_id:
                     this.event_edit_freqtype.id == this.SPECIAL_EVENT
                        ? ""
                        : this.event_add_location.location_id,
                  freq: this.event_edit_freqtype.id,
                  // consent_required: this.event_add_consent_required,
                  // cca_fee: this.event_add_cca_fee,
                  special_location: this.event_add_special_location,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.reloadEventList();
                  }
               }
            });
         },

         addNewEvent() {
            if (this.$refs.addeventform.validate()) {
               let now = this.$date();
               let event_date = this.$date(this.event_add_date + " " + this.event_add_starttime);

               if (now.isAfter(event_date)) {
                  this.ShowMessage({
                     title: "Error",
                     message: "Past events are not allowed.",
                     color: "red",
                  });
               } else if (this.event_add_starttime >= this.event_add_endtime) {
                  this.ShowMessage({
                     title: "Error",
                     message: "End time must be greater than start time.",
                     color: "red",
                  });
               } else if (!this.event_add_location && this.event_edit_freqtype.id == 0) {
                  this.ShowMessage({
                     title: "Error",
                     message: "Please select a location.",
                     color: "red",
                  });
               } else if (this.event_edit_freqtype.id == 1 && !this.event_add_special_location) {
                  this.ShowMessage({
                     title: "Error",
                     message: "Please enter the location for this special event.",
                     color: "red",
                  });
               } else {
                  this.doAddNewEvent();
               }
            } else {
               this.ShowMessage({
                  title: "Error",
                  message: "Please complete the form.",
                  color: "red",
               });
            }
         },

         showAddEventDialog() {
            this.event_add_date = this.todayDate();
            this.addeventdlg = true;
         },

         onEventDateChange(date) {
            this.event_add_date = date;
         },

         editEvent(item) {
            this.event_edit_eventid = item.event_id;
            this.event_edit_freqtype.id = 0;
            this.event_editdate = item.event_date;
            this.event_edit_description = item.event_description;

            this.event_edit_starttime = item.event_starttime;
            this.event_edit_endtime = item.event_endtime;
            this.event_edit_consent_required = item.consent_required;

            this.event_edit_location = this.event_locationdata.find(
               (x) => x.location_id == item.event_location_id
            );

            this.event_edit_special_location = item.special_location;
            this.editeventdlg = true;
         },

         async deleteEvent(item) {
            if (item) {
               let today = this.$globalstore.currentDateISOString().substr(0, 10);
               if (item.event_date <= today) {
                  this.ShowMessage({
                     title: "Error",
                     message: "Cannot delete today's or past event.",
                     color: "red",
                  });
               } else {
                  this.$refs.confirmreason
                     .open(
                        "Warning",
                        "Are you sure you want to delete event for " +
                           item.event_date +
                           "? Please provide a reason.",
                        {color: "orange", noconfirm: false}
                     )
                     .then((reply) => {
                        if (reply) {
                           this.doDeleteEvent(item);
                        }
                     });
               }
            }
         },

         saveDeleteReason(reason) {
            this.deleteReason = reason;
         },

         async doDeleteEvent(item) {
            await this.$http({
               url: "/cca/removeevent_byid.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  event_id: item.event_id,
                  reason: this.deleteReason,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.reloadEventList();
                  }
               }
            });
         },

         async reloadEventList() {
            await this.$http({
               url: "/cca/geteventlist.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  cca_id: this.cca_id,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.event_eventdata = response.data.eventdata;
                     this.$emit("save-eventlist", response.data.eventdata);
                  }
               }
            });
         },

         eventdata_rowClick(item, row) {
            row.select(!row.isSelected);
         },

         async eventUpdateEvent() {
            await this.$http({
               url: "/cca/updateevent_byid.php",
               headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
               },
               data: {
                  event_id: this.event_edit_eventid,
                  event_description: this.event_edit_description,
                  event_location_id: this.event_edit_location.location_id,
                  event_starttime: this.event_edit_starttime,
                  event_endtime: this.event_edit_endtime,
                  event_special_location: this.event_edit_special_location,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.editeventdlg = false;
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.editeventdlg = false;

                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.reloadEventList();
                  }
               }
            });
            this.editeventdlg = false;
         },

         showAttendance(event) {
            this.$router.push({
               name: "AttendanceView",
               params: {
                  cca_id: this.cca_id,
                  eventid: event.event_id,
                  eventdate: event.event_date,
               },
            });
         },

         async LoadLocationList() {
            await this.$http({
               url: "/cca/locationlist.php",
               method: "POST",
            }).then((response) => {
               const data = response.data;
               if (!data.error) {
                  this.event_locationdata = data.locationlist;
               } else {
                  this.event_locationdata = [];
               }
            });
         },
      },

      async mounted() {
         if (this.$globalstore && this.$globalstore.appready) {
            this.reloadEventList();
            this.LoadLocationList();
            this.event_edit_freqtype = this.eventFreqType[this.SPECIAL_EVENT];
         }
      },
   };
</script>
